<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :before-close="handleClose" class="report4">
    <table-form :dataSource="dataSource" ref="form" :tableData="data"></table-form>
    <table-temp :tableData="tableData" :columnData="tableConf" :isEdit="false">
      <el-table-column label="操作" width="100" slot="other">
        <template slot-scope="scope">
          <a href="javascript:void(0);" class="input">
            上传
            <input
              :key="dialogFormVisible"
              type="file"
              class="file"
              @change="getFile($event, scope)"
              accept="application/pdf,application/x-zip-compressed,application/x-rar-compressed"
            />
          </a>
        </template>
      </el-table-column>
    </table-temp>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from 'common/components/form/tableForm'
import TableTemp from '@table/table'
import { selectDic, saveReportLargeChange, singleUploadQuarter } from 'common/js/api'
import { step4 } from '@/conf/Report-manager'

const tableConf = [
  {
    label: '材料名称',
    field: 'name',
    formtype: '',
    require: false
  },
  {
    label: '附件名称',
    field: 'uploadName',
    formtype: '',
    require: false
  }
]

export default {
  components: {
    TableForm,
    TableTemp
  },

  props: ['dialogVisible', 'title', 'data', 'codeId'],

  data() {
    return {
      dataSource: step4,
      dialogFormVisible: false,
      formData: {},
      tableConf,
      tableData: [
        {
          id: 0,
          name: '附件',
          uploadName: '',
          storePath: ''
        }
      ]
    }
  },

  mounted() {},

  methods: {
    handleClose() {
      this.dialogFormVisible = false
      this.tableData[0].uploadName = ''
      this.tableData[0].storePath = ''
      this.$emit('closeDialog')
    },

    // 上传文件
    async getFile(event) {
      let file = event.target.files[0]
      let fileName = file.name
      if (file) {
        let idx = fileName.lastIndexOf('.')
        if (idx != -1) {
          let ext = fileName.substr(idx + 1).toUpperCase()
          ext = ext.toLowerCase()
          if (ext != 'pdf' && ext != 'rar' && ext != 'zip') {
            this.$message.error('请上传格式正确的文件，支持pdf、rar和zip')
          } else {
            this.file = file
            if (this.file) {
              const res = await this.submitUpload(event)
              this.tableData[0].uploadName = res.result.orignName
              this.tableData[0].title = '已登记无须提供'
              this.tableData[0].storePath = res.result.storePath
            }
          }
        }
      }
    },

    async submitUpload(event) {
      event.preventDefault()
      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('institutionName', this.$route.query.institutionName)
      //上传重大事项使用标识B
      const result = await singleUploadQuarter(formData, 'B')
      this.$message({
        message: '上传成功',
        type: 'success'
      })
      return result
    },

    async submit() {
      const isValidate = this.$refs.form.submitForm()
      if (!isValidate) return false
      let form = this.$refs.form.form

      // code id
      form.reportCode = this.codeId
      if (this.title.includes('编辑')) {
        form.id = this.data.id
      }
      form.changeFileOrginName = this.tableData[0].uploadName
      form.changeFileStorePath = this.tableData[0].storePath
      await saveReportLargeChange(form)
      const message = this.title.includes('添加') ? '添加' : '编辑'
      this.$message({
        message: `企业重大变更事项${message}成功!`,
        type: 'success'
      })
      this.$emit('reload')
      this.handleClose()
    },

    editFileName(data) {
      if (!data.changeFileOrginName) return
      this.tableData[0].uploadName = data.changeFileOrginName
      this.tableData[0].storePath = data.changeFileStorePath
    }
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue
    },
    data: {
      handler(newValue) {
        this.editFileName(newValue)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
/*input*/
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  width: 70px;
  /* border-radius: 5px; */
  height: 30px;
  margin-top: 1px;
  vertical-align: top;
  line-height: 28px;
  /* background: #409EFF; */
  /* background: #3091d1; */
  text-align: center;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: bottom;
}

/* a.input:hover {
  background: #66b1ff;
  color: #ffffff;
} */

a {
  text-decoration: none;
  color: #7567a9;
  position: absolute !important;
  right: 0px;
  top: 10px;
}

.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
}
</style>
<style lang="scss" scoped>
::v-deep .el-form-item__label {
  width: 150px !important;
}
::v-deep .el-form-item__content {
  margin-left: 150px !important;
}
</style>